import ListItem from '@material-ui/core/ListItem';
import styles from '@styles/hrRequest.module.css';

export default function HRRequestTypeCard({
    title,
    description,
    icon,
    disabled,
    onClick
}) {
    return (
        <ListItem
            className={styles.konekCard}
            button={!disabled}
            style={{
                width: '100%',
                marginBottom: '12px',
                padding: '16px',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? 'default' : 'pointer'
            }}
            onClick={!disabled ? onClick : undefined}
        >
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ marginRight: '12px', alignSelf: 'center' }} >
                    {icon}
                </div>

                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: '15px' }} >
                        {title}
                    </div>

                    <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }} >
                        {description}
                    </div>
                </div>
            </div>
        </ListItem>
    );
}